import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import Admin from "@/pages/Admin";
import LocationPage from "@/pages/LocationPage";
import { locations } from "@/data/locations";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/admin" element={<Admin />} />
          {locations.map((l) => (
            <Route
              key={l.slug}
              path={`/heat-pump-installation-${l.slug}`}
              element={<LocationPage slug={l.slug} />}
            />
          ))}
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
